import { Paragraph2 } from 'inpock-ui-react';
import dayjs from 'dayjs';

import { OrdersDetailResponse } from '@/apis';
import { useToast } from '@/hooks';
import { copy } from '@/utils';
import { OrderStatus } from '@/apis';

import { OrderInfoLine } from '../../checkout/OrderInfoLine';

import * as S from './styled';

interface OrderInfoSummaryProps {
  order: OrdersDetailResponse;
}

function Info({ order }: Partial<OrderInfoSummaryProps>) {
  const isUnpaid = order?.orders.some((order) => order.status === OrderStatus.UNPAID);

  const toastOn = useToast();
  if (!order) return <></>;

  const onClickCopyAccount = () => {
    if (!order) return;
    if (copy(order.account as string)) {
      toastOn('계좌번호가 복사되었어요 😎');
      return;
    }

    toastOn('계좌번호 복사에 실패했어요 😢');
  };

  if (isUnpaid) {
    return (
      <>
        <S.OrderInfoAccount>
          <Paragraph2>입금계좌</Paragraph2>
          <span className="account-number d-flex align-items-center" style={{ gap: '6px' }}>
            <Paragraph2>
              {order.bank_name ?? ''} {order.account ?? ''}
            </Paragraph2>
            <S.ButtonCopy onClick={onClickCopyAccount} />
          </span>
        </S.OrderInfoAccount>
        <OrderInfoLine
          label="입금기한"
          content={`${dayjs(order.expire_date ?? '').format('YYYY. MM. DD HH:mm')}`}
          labelColor="gray700"
          valueColor="orange"
        />
        <OrderInfoLine
          label="입금 금액"
          content={`${(order.amount ?? '')?.toLocaleString() ?? ''}원`}
          labelColor="gray700"
          valueColor="orange"
        />
      </>
    );
  }

  if (!order.paid_at) {
    return <></>;
  }

  return (
    <>
      <OrderInfoLine
        label="결제일시"
        content={`${dayjs(order.paid_at ?? '').format('YYYY. MM. DD HH:mm:ss')}`}
        labelColor="gray700"
        labelFontWeight="regular"
      />
      <OrderInfoLine
        label="총 결제 금액"
        content={`${(order?.total_price ?? '').toLocaleString()}원`}
        labelColor="gray700"
        valueColor="orange"
      />
    </>
  );
}

export function OrderInfoSummary({ order }: OrderInfoSummaryProps) {
  if (!order) {
    return <></>;
  }

  return (
    <S.Container>
      <Info order={order} />
    </S.Container>
  );
}
